import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

// Generell sollten manuelle Subscriptions eher vermieden werden
// An den Stellen wo es sich nicht vermeiden lässt, soll dieser Service das Unsubscriben vereinfachen.
// Dieser Service vereinfacht das Handling von Subscriptions
// Er wird mit Hilfe von `providers: [CleanupService]` injected, wodurch jedes mal eine neue Instanz erzeugt wird
// In den manuellen Subscriptions kann dann mittels `.pipe(takeUntil(this.destroyService.destroyed$))` die Subscription gehandelt werden.
// Somit muss nicht in jeder Component eine ngOnDestroy-Hook mit einem Subscriptionhandler implementiert werden.
@Injectable()
export class CleanupService implements OnDestroy {
  private readonly _destroyed$ = new Subject<void>();

  public destroyed$ = this._destroyed$.asObservable();

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
